function deprecatedStr(deprecated, now, changelog = '') {
  return `[vue-formily] ${deprecated} was deprecated, please use ${now}.${changelog ? ` Changelog for ${changelog}` : ''}`
}

export function warnDeprecated(deprecated, now, changelog) {
  console.warn(deprecatedStr(deprecated, now, changelog)) // eslint-disable-line no-console
}

export function errorDeprecated(deprecated, now, changelog) {
  console.error(deprecatedStr(deprecated, now, changelog)) // eslint-disable-line no-console
}
